const AUTH_KEYS = ["accessToken", "user", "refreshToken"] as const

export default function currentStorage(): Storage {
    return localStorage
}

export function getStoredAuth(): { accessToken: string; user: any | null } {
    for (const storage of [localStorage, sessionStorage]) {
        const accessToken = storage.getItem("accessToken")
        if (accessToken) {
            const userStr = storage.getItem("user")
            return {
                accessToken,
                user: userStr ? JSON.parse(userStr) : null,
            }
        }
    }
    return { accessToken: "", user: null }
}

export function clearAuthStorage(): void {
    for (const storage of [localStorage, sessionStorage]) {
        for (const key of AUTH_KEYS) {
            storage.removeItem(key)
        }
    }
    localStorage.removeItem("valuesOfRememberMe")
}
